export default "__VITE_ASSET__C3ipoA7m__"